import {
  FiBox,
  FiCheckCircle,
  FiClock,
  FiPackage,
  FiTruck,
  FiXCircle,
  FiRotateCcw,
} from "react-icons/fi";


/* =========================================================
   ORDER STATUSES
========================================================= */

export const ORDER_STATUSES = [
  "pending",
  "confirmed",
  "processing",
  "packed",
  "shipped",
  "out_for_delivery",
  "delivered",
  "cancelled",
  "returned",
];


/* =========================================================
   ORDER STATUS LABELS
========================================================= */

export const ORDER_STATUS_LABELS = {
  pending:
    "Pending",

  confirmed:
    "Confirmed",

  processing:
    "Processing",

  packed:
    "Packed",

  shipped:
    "Shipped",

  out_for_delivery:
    "Out for Delivery",

  delivered:
    "Delivered",

  cancelled:
    "Cancelled",

  returned:
    "Returned",
};


/* =========================================================
   ORDER STATUS FLOW
========================================================= */

export const ORDER_STATUS_FLOW = [
  "pending",
  "confirmed",
  "processing",
  "packed",
  "shipped",
  "out_for_delivery",
  "delivered",
];


/* =========================================================
   STATUS DASHBOARD CARDS

   IMPORTANT:
   Store COMPONENT references here.

   Correct:
       icon: FiPackage

   Wrong:
       icon: <FiPackage />

   OrderManagement renders these using:
       const Icon = item.icon;
       <Icon />
========================================================= */

export const ORDER_STATUS_CARDS = [
  {
    key:
      "",

    label:
      "All Orders",

    icon:
      FiPackage,
  },

  {
    key:
      "pending",

    label:
      "Pending",

    icon:
      FiClock,
  },

  {
    key:
      "confirmed",

    label:
      "Confirmed",

    icon:
      FiCheckCircle,
  },

  {
    key:
      "processing",

    label:
      "Processing",

    icon:
      FiBox,
  },

  {
    key:
      "packed",

    label:
      "Packed",

    icon:
      FiPackage,
  },

  {
    key:
      "shipped",

    label:
      "Shipped",

    icon:
      FiTruck,
  },

  {
    key:
      "out_for_delivery",

    label:
      "Out for Delivery",

    icon:
      FiTruck,
  },

  {
    key:
      "delivered",

    label:
      "Delivered",

    icon:
      FiCheckCircle,
  },

  {
    key:
      "cancelled",

    label:
      "Cancelled",

    icon:
      FiXCircle,
  },

  {
    key:
      "returned",

    label:
      "Returned",

    icon:
      FiRotateCcw,
  },
];


/* =========================================================
   PAYMENT STATUSES
========================================================= */

export const PAYMENT_STATUSES = [
  "pending",
  "paid",
  "failed",
  "refunded",
  "partially_refunded",
];


/* =========================================================
   PAYMENT STATUS LABELS
========================================================= */

export const PAYMENT_STATUS_LABELS = {
  pending:
    "Pending",

  paid:
    "Paid",

  failed:
    "Failed",

  refunded:
    "Refunded",

  partially_refunded:
    "Partially Refunded",
};


/* =========================================================
   PAYMENT METHODS
========================================================= */

export const PAYMENT_METHODS = [
  {
    value:
      "cod",

    label:
      "Cash on Delivery",
  },

  {
    value:
      "online",

    label:
      "Online",
  },
];


/* =========================================================
   DATE PRESETS
========================================================= */

export const DATE_PRESETS = [
  {
    value:
      "today",

    label:
      "Today",
  },

  {
    value:
      "this_week",

    label:
      "This Week",
  },

  {
    value:
      "this_month",

    label:
      "This Month",
  },

  {
    value:
      "this_year",

    label:
      "This Year",
  },

  {
    value:
      "custom",

    label:
      "Custom",
  },
];


/* =========================================================
   PAGE LIMITS
========================================================= */

export const ORDER_PAGE_LIMITS = [
  10,
  20,
  50,
  100,
];